<template>
	<div>
		<aside v-if="!ready" class="app-loading">
			<p>Loading Online Scheduling...</p>
		</aside>
		<aside v-if="ready" class="online-scheduling">
			<div v-if="loading" class="loading"></div>
			<div class="content" :class="{'dimmed': loading}">
				<div class="main" >
					<span class="title d-block text-center">Schedule an Appointment in <strong>{{ clinic.name }}</strong></span>
					<button class="btn-beltone lg mx-auto d-block my-3" @click="changeLocations()">Change Locations</button>
					<div class="progress-status">
						<div class="step" :class="getStepState(1)">
							<img class="icon" alt="Step 1" :src="`images/step1-${getStepState(1)}.svg`"/>
							<label class="header">Step 1</label>
							<label class="copy">Select Day & Time</label>
							<div class="bar"></div>
						</div>
						<div class="step" :class="getStepState(2)">
							<img class="icon" alt="Step 2" :src="`images/step2-${getStepState(2)}.svg`"/>
							<label class="header">Step 2</label>
							<label class="copy">Provide Information</label>
							<div class="bar"></div>
						</div>
						<div class="step" :class="getStepState(3)">
							<img class="icon" alt="Step 3" :src="`images/step3-${getStepState(3)}.svg`"/>
							<label class="header">Step 3</label>
							<label class="copy">Confirmation</label>
							<div class="bar"></div>
						</div>
					</div>
				</div>
				<step-1 v-if="step === 1" :clinicId="clinic.id"/>
				<step-2 v-if="step === 2"/>
				<step-3 v-if="step === 3"/>
				<step-4 v-if="step === 4"/>
			</div>
		</aside>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';
	import Services from '../mixins/services';
	import Step1 from './../components/online-scheduling/step-1';
	import Step2 from './../components/online-scheduling/step-2';
	import Step3 from './../components/online-scheduling/step-3';
	import Step4 from './../components/online-scheduling/step-4';

	export default {
		mixins: [Services],
		props: ['clinicUrl'],
		components: {
			Step1,
			Step2,
			Step3,
			Step4
		},
		data: function () {
			return {
				ready: false,
			}
		},
		watch: {
			clinicUrl: {
				immediate: true,
				handler(value) {
					if (value.length > 0) {
						this.init();
					}
				}
			},
		},
        computed: mapState({
			step: state => state.OnlineScheduling.step,
			clinic: state => state.OnlineScheduling.clinic,
			globals: state => state.OnlineScheduling.globals,
			loading: state => state.OnlineScheduling.loading,
			clientToken: state => state.ClientToken.clientToken,
		}),
		methods: {
			...mapActions('ClientToken', { getClientToken: 'getClientToken' }),
			...mapActions('OnlineScheduling', { updateLoading: 'updateLoading' }),
			...mapActions('OnlineScheduling', { getClinicInformation: 'getClinicInformation' }),
			...mapActions('OnlineScheduling', { getCompanionTypes: 'getCompanionTypes' }),
			getStepState(step) {
				if (this.step === step) {
					return 'focus';
				} else if (this.step > step) {
					return 'complete';
				} else if (this.step < step) {
					return 'inactive';
				}
			},
			changeLocations() {
                window.top.location.href = `${document.referrer}${this.globals.changeLocations}`;
			},
			init() {
				this.getClientToken({
					cb: () => {
						this.getClinicInformation({
							ClinicUrl: this.clinicUrl,
							ClientToken: this.clientToken,
							cb: () => {
								this.getCompanionTypes({
									ClientToken: this.clientToken,
									cb: () => {
										this.ready = true;
										this.updateLoading(false);
										setInterval(() => {
											let height = $('body').outerHeight(); // IMPORTANT: If body's height is set to 100% with CSS this will not work.
											parent.postMessage("resize::onlineScheduling" + height,"*");
										}, 1000);
									}
								});
							}
						})
					}
				});
			}
		},
		created() {
			// https://localhost:7224/onlinescheduling?utm_source=Google&utm_medium=PPC&utm_campaign=nashvilletn&utm_content=HearingTest
			// const urlParams = new URLSearchParams(window.location.search);
			// if (urlParams.get('utm_source')) sessionStorage.setItem('utm_source', urlParams.get('utm_source'));
			// if (urlParams.get('utm_medium')) sessionStorage.setItem('utm_medium', urlParams.get('utm_medium'));
			// if (urlParams.get('utm_campaign')) sessionStorage.setItem('utm_campaign', urlParams.get('utm_campaign'));
			// if (urlParams.get('utm_content')) sessionStorage.setItem('utm_source', urlParams.get('utm_content'));
		}
    }
</script>
